import { Banner } from '@trackman/baseball-shared-components';
import { ToastProps } from '@trackman/web-shared-components';
import { makeAutoObservable } from 'mobx';

export class NotificationStore {
  notifications: Banner[] = [];

  toast: ToastProps | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  addNotification(notification: Banner) {
    this.notifications = [...this.notifications, notification];
  }

  removeNotification(notificationId: string) {
    this.notifications = this.notifications.filter((n) => n.id !== notificationId);
  }

  addToast(toast: ToastProps) {
    this.toast = toast;
  }

  removeToast() {
    this.toast = undefined;
  }
}
